import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { convertNumericUnitToString } from "../utils/utils";

interface UseUnitSyncParams {
  control: any;
  parentControl: any | undefined;
}

/**
 * Derives the resolved display unit string ("kg" | "ton") for formatted outputs.
 *
 * When parentControl is provided the parent form is authoritative for display.
 * Unit writes (parent ↔ child) are handled by useWasteFormSync and event handlers.
 */
export const useUnitSync = ({ control, parentControl }: UseUnitSyncParams): string => {
  const internalSideStreamUnit = useWatch({ control, name: "sideStreamUnit" });

  /**
   * Always call useWatch regardless of whether parentControl exists.
   * React's Rules of Hooks require the same number of hook calls every render.
   */
  const parentSideStreamUnitRaw = useWatch({
    control: parentControl || control,
    name: "sideStreamUnit"
  });

  return useMemo(() => {
    const rawUnit = parentControl ? parentSideStreamUnitRaw : internalSideStreamUnit;
    return convertNumericUnitToString(rawUnit || "kg");
  }, [parentControl, parentSideStreamUnitRaw, internalSideStreamUnit]);
};
